module.exports = __webpack_public_path__ + "img/ais-target-heading-c.27e50060.svg";